import { ResolveFn } from "@angular/router";
import { UserStore } from "../../store/user/user.store";
import { inject } from "@angular/core";
import { FeeScheduleStore } from "../../store/fee-schedule/fee-schedule.store";

export const feeScheduleResolver: ResolveFn<any> = async () => {
      const userStore = inject(UserStore)
      const feeSchedule = inject(FeeScheduleStore)
      const provider_id = userStore.provider_id()

      try {
        await feeSchedule.getFeeScheduleById(provider_id)
      } catch(err) {
        console.error('Error fetching fee schedule:', err); 
      }
}